// // src/lib/axios.js - Axios instance configuration
// import axios from 'axios';

// const baseURL = process.env.REACT_APP_API_URL || 'http://your-api-base-url';

// export const axiosInstance = axios.create({
//   baseURL,
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Add interceptors if needed
// axiosInstance.interceptors.request.use(
//   (config) => {
//     // Get token from localStorage or wherever you store it
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // src/lib/react-query.js - React Query client configuration
// import { QueryClient } from '@tanstack/react-query';

// export const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       refetchOnWindowFocus: false,
//       retry: 1,
//       staleTime: 5 * 60 * 1000, // 5 minutes
//     },
//   },
// });

// // src/api/api-services.js - API service functions
// import { axiosInstance } from '../lib/axios';

// export const apiServices = {
//   // Events
//   getEvents: async () => {
//     const { data } = await axiosInstance.get('/events');
//     return data;
//   },
  
//   getEventById: async (id) => {
//     const { data } = await axiosInstance.get(`/events/${id}`);
//     return data;
//   },

//   // Testimonials
//   getTestimonials: async () => {
//     const { data } = await axiosInstance.get('/testimonials');
//     return data;
//   },

//   // News
//   getNews: async () => {
//     const { data } = await axiosInstance.get('/news');
//     return data;
//   },

//   // Programs
//   getPrograms: async () => {
//     const { data } = await axiosInstance.get('/programs');
//     return data;
//   },
// };

// // src/hooks/useApi.js - Custom hooks for API calls
// import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
// import { apiServices } from '../api/api-services';

// // Query hooks
// export const useEvents = () => {
//   return useQuery({
//     queryKey: ['events'],
//     queryFn: apiServices.getEvents,
//   });
// };

// export const useEvent = (id) => {
//   return useQuery({
//     queryKey: ['events', id],
//     queryFn: () => apiServices.getEventById(id),
//     enabled: !!id, // Only run if id exists
//   });
// };

// export const useTestimonials = () => {
//   return useQuery({
//     queryKey: ['testimonials'],
//     queryFn: apiServices.getTestimonials,
//   });
// };

// export const useNews = () => {
//   return useQuery({
//     queryKey: ['news'],
//     queryFn: apiServices.getNews,
//   });
// };

// export const usePrograms = () => {
//   return useQuery({
//     queryKey: ['programs'],
//     queryFn: apiServices.getPrograms,
//   });
// };

// // src/App.jsx - Root component setup
// import { QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// import { queryClient } from './lib/react-query';

// const App = () => {
//   return (
//     <QueryClientProvider client={queryClient}>
//       {/* Your app components */}
//       <ReactQueryDevtools initialIsOpen={false} />
//     </QueryClientProvider>
//   );
// };

// // Example usage in a component
// // src/components/EventsSection.jsx
// import { useEvents } from '../hooks/useApi';
// import { CircularProgress, Alert } from '@mui/material';

// const EventsSection = () => {
//   const { data: events, isLoading, isError, error } = useEvents();

//   if (isLoading) {
//     return (
//       <Box display="flex" justifyContent="center" p={4}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (isError) {
//     return (
//       <Alert severity="error">
//         Error loading events: {error.message}
//       </Alert>
//     );
//   }

//   return (
//     <Box sx={{ py: 8, bgcolor: 'background.default' }}>
//       <Container maxWidth="lg">
//         <Typography variant="h3" align="center" gutterBottom>
//           Events & Activities
//         </Typography>
        
//         <Grid container spacing={4}>
//           {events.map((event) => (
//             <Grid item xs={12} sm={6} md={4} key={event.id}>
//               <EventCard event={event} />
//             </Grid>
//           ))}
//         </Grid>
//       </Container>
//     </Box>
//   );
// };

// // Example of handling mutations (POST, PUT, DELETE)
// // src/hooks/useApi.js
// export const useAddEvent = () => {
//   const queryClient = useQueryClient();
  
//   return useMutation({
//     mutationFn: (newEvent) => apiServices.addEvent(newEvent),
//     onSuccess: () => {
//       // Invalidate and refetch events after successful addition
//       queryClient.invalidateQueries(['events']);
//     },
//   });
// };

// // Usage in a component
// const AddEventForm = () => {
//   const addEvent = useAddEvent();

//   const handleSubmit = (eventData) => {
//     addEvent.mutate(eventData, {
//       onSuccess: () => {
//         // Handle success (e.g., show notification, reset form)
//       },
//       onError: (error) => {
//         // Handle error
//       },
//     });
//   };

//   return (
//     // Your form JSX
//   );
// };

import { toast } from "react-hot-toast";
const token = localStorage.getItem('token');

export const handleAddToFavorite = async (url) => {
  
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`, // Ensure token is included
            },
        });
  
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        console.log("Added to favorite successfully:", response);
        toast.success("Added to favorite successfully!", {
          duration: 4000, // Duration for the toast to stay visible
          position: "top-right", // Position of the toast (can be 'top-left', 'top-right', 'bottom-left', 'bottom-right')
        });
    } catch (err) {
        console.error("Error adding to favorite:", err);
    }
  };
  export const handleConfirmOrder = async (url, setOpenModal) => {
  
    try {
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`, // Ensure token is included
            },
        });
  
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        console.log("Order confirmed successfully:", response);
        setOpenModal(true)
    } catch (err) {
        console.error("Error confirming order:", err);
    }
  };

  export const handleCheckout = async (url, data) => {
  
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`, // Ensure token is included
            },
        });
  
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        console.log("Added to favorite successfully:", response);
        toast.success("Added to favorite successfully!", {
          duration: 4000, // Duration for the toast to stay visible
          position: "top-right", // Position of the toast (can be 'top-left', 'top-right', 'bottom-left', 'bottom-right')
        });
    } catch (err) {
        console.error("Error adding to favorite:", err);
    }
  };

  export const handlePlaceOrder = async (event, url, data, setOnClose, setOpenModal) => {
    event.preventDefault()

    try {
        const response = await fetch(url, {
            method: "POST", // Specify the HTTP method
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`, // Ensure token is included
            },
            body: JSON.stringify(data), // Convert the data object to a JSON string
        });

        if (!response.ok) {
            // Handle HTTP errors
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json(); // Parse the response JSON
        console.log("Update successful:", result);
        setOnClose(false)      
        setOpenModal(true)
    } catch (error) {
        console.error("Error updating:", error);
    }
};